import { render, staticRenderFns } from "./Pos_Header.vue?vue&type=template&id=0579d3dd&"
import script from "./Pos_Header.vue?vue&type=script&lang=js&"
export * from "./Pos_Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports